import { ExteriorDeficiencyLayout } from './ExteriorDeficiency.layout';
import { MechanicalDeficiencyLayout } from './MechanicalDeficiency.layout';
import { ExteriorUpdateLayout } from './ExteriorUpdate.layout';
import { ExteriorFeatureLayout } from './ExteriorFeature.layout';

export class StructureLayout {
	public fields = [
		{ fieldName: 'attachmentType' },
		{ fieldName: 'structureType' },
		{ fieldName: 'constructionType' },
		{ fieldName: 'constructionStatus' },
		{ fieldName: 'yearBuilt' },
		{ fieldName: 'yearBuiltEstimate' },
		{ fieldName: 'effectiveAge' },
		{ fieldName: 'cv_foundationSlabType' },
		{ fieldName: 'cv_foundationCrawlSpaceType' },
		{ fieldName: 'cv_exteriorFeaturesFoundation' },
		{ fieldName: 'cv_exteriorFeaturesWalls' },
		{ fieldName: 'cv_exteriorRoofType' },
		{ fieldName: 'cv_foundationSumpPump' }
	];

	public fieldsArray = [
		{
			fieldName: 'exteriorDeficiencies',
			label: 'Exterior Deficiencies',
			fields: new ExteriorDeficiencyLayout().fields
		},
		{
			fieldName: 'mechanicalDeficiencies',
			label: 'Mechanical Deficiencies',
			fields: new MechanicalDeficiencyLayout().fields
		},
		{
			fieldName: 'exteriorUpdates',
			label: 'Exterior Updates',
			fields: new ExteriorUpdateLayout().fields
		},
		{
			fieldName: 'exteriorFeatures',
			label: 'Exterior Features',
			fields: new ExteriorFeatureLayout().fields
		}
	];
}
